import React, { useContext, useEffect, useState } from 'react';
import '../css/ConfirmationList.css';
import Navbar from './Navbar';
import Footer from './Footer';
import { BaseUrl, fetchGroupRegList, pipPrePayment } from '../Services/Api';
import { MoonLoader } from "react-spinners";
import Spinner from '../helperComponents/Spinner';
import { TransactionContext } from '../context/TransactionContext';

const ConfirmationList = () => {

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const { transactionId } = useContext(TransactionContext);

  useEffect(() => {
    const fetchFun = async () => {
      // const transactionId = '27082025c8y2wi854';
      try {
        const response = await fetchGroupRegList(transactionId);
        setList(response.data);
        console.log(response.data);
        // console.log(response.data.transaction_id);

        setLoading(false);
        // console.log(response.data);

      } catch (err) {
        console.log(err);

      }
    }

    fetchFun();
  }, []);


  const handlePaymentSubmit = async (transactionId) => {
    // console.log(transactionId);

    try {
      const response = await pipPrePayment(transactionId);
      // console.log(response);

    } catch (err) {
      console.log(err);

    }
  }
  return (
    <>
      <Navbar />
      <div className="fur-container">
        {/* <header className="fur-header">
      
        <h1 className="fur-title">User Conformation </h1>
        <p className="fur-subtitle">Registrant Management Portal</p>
      </header> */}

        {/* Stats Overview */}
        <div className="fur-stats-container">
          <div className="fur-stat-card">
            <div className="fur-stat-icon fur-stat-success">
              <i className="fas fa-check-circle"></i>
            </div>
            <div className="fur-stat-content">
              {
                loading ? (
                  <Spinner />
                ) :
                  list.list && list.list.length > 0 ? (
                    <h3>{list.list.length}</h3>
                  ) : (
                    <h3>0</h3>
                  )
              }

              <p>Successful Registrations</p>
            </div>
          </div>

          <div className="fur-stat-card">
            <div className="fur-stat-icon fur-stat-warning">
              <i className="fas fa-exclamation-triangle"></i>
            </div>
            <div className="fur-stat-content">
              {
                loading ? (
                  <Spinner />
                ) :
                  list.duplicates && list.duplicates.length > 0 ? (
                    <h3>{list.duplicates.length}</h3>
                  ) : (
                    <h3>0</h3>
                  )
              }
              <p>Duplicate Entries</p>
            </div>
          </div>

          <div className="fur-stat-card">
            <div className="fur-stat-icon fur-stat-primary">
              <i className="fas fa-receipt"></i>
            </div>
            <div className="fur-stat-content">
              {
                loading ? (
                  <Spinner />
                ) :
                  list.count && list.count.length > 0 ? (
                    list.count.map((row, index) => {
                      const total = row.course_price * row.total_rows;
                      const gst = total * row.gst / 100; // 18% GST
                      const grandTotal = total + gst;

                      return (
                        <h3 key={index}>
                          ₹ {new Intl.NumberFormat("en-IN").format(grandTotal)}
                        </h3>
                      );
                    })
                  ) : (
                    <h3>0</h3>
                  )
              }
              <p>Total Amount</p>
            </div>
          </div>
        </div>

        {/* Transaction Summary */}
        <div className="fur-card">
          <div className="fur-card-header">
            <h2 className="fur-card-title">
              <i className="fas fa-receipt"></i>
              Uploaded Registrants and Programme Details
            </h2>
            <span className="fur-transaction-id">
              <i className="fas fa-hashtag"></i>
              Transaction ID - {transactionId}
            </span>
          </div>

          <div className="fur-data-table-container">
            <table className="fur-summary-table">
              <thead>
                <tr>
                  <th>Programme Name</th>
                  <th>Registrant Fees (₹)</th>
                  <th>Number of Registrants</th>
                  <th>Total Amount (₹)</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (   // 👈 use your state that tracks API loading
                  <tr>
                    <td colSpan={4} style={{ textAlign: "center", padding: "20px" }}>
                      <Spinner />
                    </td>
                  </tr>
                ) : list.count && list.count.length > 0 ? (
                  list.count.map((row, index) => (
                    <tr key={index}>
                      <td>{row.course_name}</td>
                      <td>{row.course_price}</td>
                      <td>{row.total_rows}</td>
                      <td>{row.totalAmount}</td>
                      {/* <td>{row.total_rows * row.course_price}</td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} style={{ textAlign: "center", padding: "20px" }}>
                      No records found
                    </td>
                  </tr>
                )}


              </tbody>
            </table>
          </div>
        </div>

        {/* Uploaded Registrants */}
        <div className="fur-card">
          <h3 className="fur-section-title fur-section-success">
            <i className="fas fa-check-circle"></i>
            Uploaded Registrants Information
          </h3>

          <div className="fur-data-table-container">
            <table className="fur-data-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Firstname</th>
                  <th>Lastname</th>
                  <th>Full Name</th>
                  <th>Gender</th>
                  <th>DOB</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Aadhaar</th>
                  <th>Father Name</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="100%" style={{ textAlign: "center", padding: "20px" }}>
                      <Spinner />
                    </td>
                  </tr>
                ) : list.list && list.list.length > 0 ? (
                  list.list.map((row, index) => {
                    // Format date
                    const formattedDate = new Date(row.date_time).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    });

                    return (
                      <tr key={index}>
                        <td>{index + 1}</td> {/* ✅ S.No */}
                        <td>{row.firstname}</td>
                        <td>{row.lastname}</td>
                        <td>{row.fullname}</td>
                        <td>{row.gender}</td>
                        <td>{row.date_of_birth}</td>
                        <td>{row.emailid}</td>
                        <td>{row.phone_number}</td>
                        <td>{row.aadhar_no}</td>
                        <td>{row.father_name}</td>
                        <td>{row.city}</td>
                        <td>{row.state}</td>
                        <td>{formattedDate}</td> {/* ✅ formatted dd-mm-yy time */}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="100%" style={{ textAlign: "center", padding: "20px" }}>
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>

        {/* Duplicate Registrants */}
        <div className="fur-card">
          <h3 className="fur-section-title fur-section-duplicate">
            <i className="fas fa-exclamation-triangle"></i>
            Uploaded Duplicate Registrants Information
          </h3>

          <p className="fur-duplicate-info">
            <i className="fas fa-info-circle"></i>
            Duplicate Entries (Email ID, Aadhaar Number, Phone Number should not be same)
          </p>

          <div className="fur-data-table-container">
            <table className="fur-data-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Firstname</th>
                  <th>Lastname</th>
                  <th>Full Name</th>
                  <th>Gender</th>
                  <th>DOB</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Aadhaar</th>
                  <th>Father Name</th>
                  <th>City</th>
                  <th>State</th>
                  {/* <th>Programme</th> */}
                  <th>Date</th>
                  <th>Reason</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="100%" style={{ textAlign: "center", padding: "20px" }}>
                      <Spinner />
                    </td>
                  </tr>
                ) : list.duplicates && list.duplicates.length > 0 ? (
                  list.duplicates.map((row, index) => {
                    // Format date
                    const formattedDate = new Date(row.date_time).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    });

                    return (
                      <tr key={index}>
                        <td>{index + 1}</td> {/* ✅ S.No */}
                        <td>{row.firstname}</td>
                        <td>{row.lastname}</td>
                        <td>{row.fullname}</td>
                        <td>{row.gender}</td>
                        <td>{row.date_of_birth}</td>
                        <td>{row.emailid}</td>
                        <td>{row.phone_number}</td>
                        <td>{row.aadhar_no}</td>
                        <td>{row.father_name}</td>
                        <td>{row.city}</td>
                        <td>{row.state}</td>
                        <td>{formattedDate}</td> {/* ✅ formatted dd-mm-yy time */}
                        <td style={{ width: 'auto', textWrap: "nowrap" }}>{row.reason}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="100%" style={{ textAlign: "center", padding: "20px" }}>
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="fur-action-bar">
          <form action={`${BaseUrl}/pre-pay-process`} method="POST">
         
              <input
               
                type="hidden"
                name="transactionId"
                value={list.transactionId}
              />
         
            <button className="fur-btn fur-btn-primary">
              <i className="fas fa-money-check-alt"></i> Proceed Payment {list.transactionId}
            </button>
          </form>
        </div>
        {/* <div className="fur-action-bar">
          <button className="fur-btn fur-btn-outline">
            <i className="fas fa-download"></i> Download Report
          </button>
          <button className="fur-btn fur-btn-primary">
            <i className="fas fa-plus"></i> Add New Registrant
          </button>
        </div> */}
      </div>
      <Footer />
    </>
  );
};

export default ConfirmationList;